<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="lg"
		:title="
			modelId > 0
				? $t('transportUnits.editUnit')
				: $t('transportUnits.newUnit')
		"
	>
		<b-card no-body>
			<b-tabs no-fade pills card small :vertical="vertical" nav-class="nav-style">
				<b-tab title="General" active>
					<b-overlay :show="loading" no-wrap></b-overlay>
					<b-form @submit="onSubmit">
						<FormGroupBox :title="$t('transportUnits.info')">
							<b-form-row>
								<b-form-group
									class="col-4"
									:label="$t('transportUnits.name')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.name"
										required
									/>
								</b-form-group>
								<b-form-group
									class="col-4"
									:label="$t('transportUnits.plateNumber')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.plateNumber"
										required
									/>
								</b-form-group>
								<b-form-group
									class="col-4"
									:label="$t('global.status')"
								>
									<b-form-select
										size="sm"
										v-model="modelInfo.status"
										:options="statusOptions"
									></b-form-select>
								</b-form-group>
							</b-form-row>
							<b-form-row>
								<b-form-group
									class="col-4"
									:label="$t('transportUnits.maxPassengers')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.maxPassengers"
										required
									/>
								</b-form-group>
							</b-form-row>
							<b-form-row>
								<b-form-group
									class="col-4"
									:label="$t('transportUnits.unitBrand')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.unitBrand"
									/>
								</b-form-group>
								<b-form-group
									class="col-4"
									:label="$t('transportUnits.unitModel')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.unitModel"
									/>
								</b-form-group>
								<b-form-group
									class="col-4"
									:label="$t('transportUnits.unitModelYear')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.unitModelYear"
									/>
								</b-form-group>
							</b-form-row>
							<b-form-row>
								<b-form-group
									class="col-12"
									:label="$t('global.description')"
								>
									<b-textarea
										type="text"
										size="sm"
										v-model="modelInfo.description"
									/>
								</b-form-group>
							</b-form-row>
						</FormGroupBox>
						<hr />
						<div class="text-right">
							<b-button variant="primary" type="submit">{{
								modelId > 0
									? $t("global.update")
									: $t("global.save")
							}}</b-button>
						</div>
					</b-form>
				</b-tab>
				<b-tab :title="$t('global.image')" v-if="modelId > 0">
					<FilesRelated
						:model-id="modelId"
						model-reference="transport-units"
						unable-delete
						:file-keys="[
							{
								label: $t('transportUnits.unitPhoto'),
								keyName: 'unitPhoto'
							}
						]"
					/>
				</b-tab>
			</b-tabs>
		</b-card>
	</b-modal>
</template>

<script>
import FormGroupBox from "../../helpers/FormGroupBox.vue";
import FilesRelated from "@/components/helpers/FilesRelated";
import Resize from "../../helpers/Resize.js";

export default {
	mixins: [Resize],
	props: {
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	components: { FormGroupBox, FilesRelated },
	data() {
		let defaultModelInfo = {
			id: -1,
			name: "",
			plateNumber: "",
			maxPassengers: 2,
			unitBrand: "",
			unitModel: "",
			unitModelYear: "",
			description: "",
			status: "active"
		};
		return {
			modelId: -1,
			modelInfo: { ...defaultModelInfo },
			defaultModelInfo: { ...defaultModelInfo },
			loading: true
		};
	},
	computed: {
		statusOptions: function() {
			const optios = [];
			const elm = this.$t("statusActive");
			Object.keys(elm).forEach(item => {
				optios.push({ value: item, text: elm[item] });
			});
			return optios;
		}
	},
	methods: {
		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			this.loading = true;
			let rParams = {
				url:
					this.modelId > 0
						? `/transport-units/${this.modelId}`
						: "/transport-units",
				method: this.modelId > 0 ? "put" : "post"
			};

			rParams["data"] = this.modelInfo;
			this.$root.api
				.request(rParams)
				.then(res => {
					this.$root.showAlert(
						rParams.method == "post"
							? "Unidad agregada con éxito"
							: "Unidad actualizada con éxito"
					);
					if (res.data.id) this.loadModel(res.data.id);
					this.successCallback(res);
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		loadModel(id) {
			this.$root.auxVars.loadResourcesOpts({vm: this,resourceNames: ["transportUnitsOpts"], forceRefresh: true});
			this.modelId = id;
			this.$refs["modal-view"].show();
			this.fetchModel();
		},
		setAccessType(accessType) {
			this.modelInfo.accessType = accessType;
		},
		fetchModel() {
			if (this.modelId > 0) {
				this.loading = true;
				this.$root.api
					.get(`/transport-units/${this.modelId}`)
					.then(res => {
						this.modelInfo = { ...res.data };
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		}
	},
	mounted() {
		console.log("mounted single");
	}
};
</script>

<style></style>
